<article>
  <div class="date-picker">
    <div class="content">
      <div>
        <section>
          <h4>From</h4>
          <!-- <p-calendar [(ngModel)]="dateFrom" [inline]="true" [showWeek]="true" [minDate]="dates.min || null" [maxDate]="dates.max" [firstDayOfWeek]="1"> </p-calendar> -->
          <app-calendar [value]="dateFrom" [minDate]="dates.min || null" [maxDate]="dates.max" (onSelectDate)="dateTo = $event" />
        </section>
      </div>
      <div>
        <section>
          <h4>To</h4>
          <!-- <p-calendar [(ngModel)]="dateTo" [inline]="true" [showWeek]="true" [minDate]="dates.min || null" [maxDate]="dates.max" [firstDayOfWeek]="1"> </p-calendar> -->
          <app-calendar [value]="dateTo" [minDate]="dates.min || null" [maxDate]="dates.max" (onSelectDate)="dateTo = $event" />
        </section>
      </div>
    </div>
    <div class="actions">
      <div>
        @if (asset) {
          <!--<button  type="button" (click)="assetStart()" icon="" class="p-button-outlined"
        label="Asset start"></button>
        <button  type="button" (click)="assetEnd()" icon="" class="p-button-outlined"
        label="Asset end"></button>-->
        }
      </div>
      <div>
        <button type="button" (click)="cancel()" icon="mdi mdi-close" class="p-button-outlined" label="Cancel"></button>
        <button type="button" (click)="submit()" icon="mdi mdi-check" label="Export date range"></button>
      </div>
    </div>
  </div>
</article>
